import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaEnvelope, FaLock, FaSignInAlt, FaUserPlus } from 'react-icons/fa';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login, guestLogin } = useAuth();
  const navigate = useNavigate();

  const { email, password } = formData;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      if (result.user.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/');
      }
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen pt-16 flex justify-center items-center p-4 bg-gray-50 relative overflow-hidden">
      {/* Background Decorations */}
      <div className="absolute w-[700px] h-[700px] bg-blue-500/5 rounded-full -top-[300px] -right-[300px] blur-3xl animate-pulse"></div>
      <div className="absolute w-[600px] h-[600px] bg-amber-500/5 rounded-full -bottom-[250px] -left-[250px] blur-3xl animate-pulse delay-1000"></div>

      <div className="bg-white/80 backdrop-blur-md border border-blue-100 p-8 md:p-10 rounded-2xl shadow-xl w-full max-w-md relative z-10 animate-fade-in-down">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-2">Login to BookBazaar</h2>
        <p className="text-gray-500 text-center mb-8">Welcome back! Please login to your account.</p>
        
        {error && (
          <div className="bg-red-50 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded-r shadow-sm" role="alert">
            <p>{error}</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="email" className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
              <FaEnvelope className="text-blue-500" />
              Email
            </label>
            <div className="relative">
              <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none bg-gray-50 focus:bg-white"
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div>
            <label htmlFor="password" className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
              <FaLock className="text-blue-500" />
              Password
            </label>
            <div className="relative">
              <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none bg-gray-50 focus:bg-white"
                placeholder="Enter your password"
                required
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={loading}
          >
            <FaSignInAlt />
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div className="relative flex items-center justify-center my-4">
            <div className="border-t border-gray-300 w-full"></div>
            <span className="bg-white/80 px-3 text-sm text-gray-500 font-medium">OR</span>
            <div className="border-t border-gray-300 w-full"></div>
          </div>

          <button 
            type="button"
            onClick={async () => {
              setLoading(true);
              const result = await guestLogin();
              if (result.success) {
                navigate('/');
              } else {
                setError(result.message);
              }
              setLoading(false);
            }}
            className="w-full bg-gray-600 hover:bg-gray-700 text-white font-bold py-3 px-4 rounded-lg transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={loading}
          >
            <FaUserPlus />
            Continue as Guest
          </button>
        </form>

        <p className="text-center mt-8 text-gray-600">
          Don't have an account?{' '}
          <Link to="/signup" className="text-blue-600 hover:text-blue-800 font-semibold inline-flex items-center justify-center gap-1 transition-colors">
            <FaUserPlus />
            Sign up here
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
